import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8bf9335c")

_pushScopeId("data-v-8bf9335c")
const _hoisted_1 = { class: "expertsubtitleitem" }
const _hoisted_2 = { class: "scoreboxbig" }
const _hoisted_3 = { class: "score" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "fen" }, "分", -1)
const _hoisted_5 = { class: "tb" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "itme" }, [
  /*#__PURE__*/_createVNode("div", null, "检测指标"),
  /*#__PURE__*/_createVNode("div", null, "检测结果"),
  /*#__PURE__*/_createVNode("div", null, "提示"),
  /*#__PURE__*/_createVNode("div", null, "参考范围")
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "txt" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 评估结果：")
const _hoisted_14 = { class: "val" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ScoreNum = _resolveComponent("ScoreNum")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_ScoreNum, {
          score: _ctx.data.score,
          addZero: true
        }, null, 8, ["score"])
      ]),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.detailList, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "itme",
          key: index
        }, [
          _createVNode("div", null, _toDisplayString(item.name), 1),
          _createVNode("div", null, _toDisplayString(item.score), 1),
          _createVNode("div", null, [
            (item.result === 1)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_7
                ], 64))
              : _createCommentVNode("", true),
            (item.result === -1)
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_8
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            (!item.maxRange)
              ? (_openBlock(), _createBlock("span", _hoisted_9, "≥" + _toDisplayString(item.minRange), 1))
              : (!item.minRange)
                ? (_openBlock(), _createBlock("span", _hoisted_10, "≤" + _toDisplayString(item.maxRange), 1))
                : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(item.minRange) + "~" + _toDisplayString(item.maxRange), 1))
          ])
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode("span", _hoisted_14, _toDisplayString(_ctx.data.report_content), 1)
    ])
  ]))
})